import Controller from '../abstracts/Controller';
import 'scss-templates/t-check-gift-card.scss';

export default class CheckGiftCardController extends Controller {
  static get COMPONENTS() {
    return [];
  }
}
